module.exports = __webpack_public_path__ + "static/media/wireframing_02@3x.567806ec.png";